var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import sizes from "@bottlebooks/gatsby-design-system/src/components/icons/sizes";
/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function FacebookIcon(_a) {
    var { className, size = "xsmall" } = _a, rest = __rest(_a, ["className", "size"]);
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, className: className }, rest, { viewBox: "0 0 14222 14222", children: [_jsx("circle", { cx: 7111, cy: 7112, r: 7111, fill: "currentColor" }), _jsx("path", { d: "M9879 9168l315-2056H8222V5778c0-562 275-1111 1159-1111h897V2917s-814-139-1592-139c-1624 0-2686 984-2686 2767v1567H4194v2056h1806v4969c362 57 733 86 1111 86s749-30 1111-86V9168z", fill: "#fff" })] })));
}
//# sourceMappingURL=FacebookIcon.js.map